import { Button, Icon, Spacing, TextInput } from 'zens-storybook'
import React, { Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { Link, useNumberParams, usePaginationParam } from 'zens-router'
import { useBreadcrumb } from '@dms/hook'
import { LayoutHeader, WorkspaceTypeTable } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    margin: Spacing.L,
  },
  header: {
    flexDirection: 'row',
  },
  search: {
    minWidth: 300,
    marginRight: Spacing.S,
  },
})

const ScreenWorkspaceTypeList = () => {
  const [search, setSearch] = useState('')
  const [{ companyId }] = useNumberParams()
  const { t } = useTranslation()
  const [pagination, setPagination] = usePaginationParam()

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspace types'),
    },
  ])

  function updateSearch(search: string) {
    setSearch(search)
    setPagination({ page: 0, size: pagination.size })
  }

  const renderHeader = () => {
    return (
      <View style={styles.header}>
        <TextInput
          left="search"
          placeholder={t('Search type name')}
          right={
            search ? (
              <TouchableOpacity onPress={() => updateSearch('')} testID="WorkspaceTypeList.Search.Clear">
                <Icon name="close" size="S" />
              </TouchableOpacity>
            ) : undefined
          }
          value={search}
          onChangeText={updateSearch}
          style={styles.search}
          testID="WorkspaceTypeList.Search"
        />
        <Link href={{ pathname: `/workspacetypes/add`, params: { companyId } }} asChild>
          <Button title={t('Create workspace type')} left="plus" testID="WorkspaceTypeList.Add" />
        </Link>
      </View>
    )
  }

  return (
    <View style={styles.container}>
      <LayoutHeader breadcrumb={breadcrumb} title={t('Workspace types')} accessory={renderHeader()} menu={undefined} />
      <View style={styles.content}>
        <Suspense fallback={<WorkspaceTypeTable.Skeleton />}>
          <WorkspaceTypeTable
            companyId={companyId}
            search={search}
            pagination={pagination}
            onPaginationChange={setPagination}
          />
        </Suspense>
      </View>
    </View>
  )
}

export default ScreenWorkspaceTypeList
